import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@base/environments/environment';
import { usesAppLogin } from '../../root-redirect.guard';
import { LoginFlow } from '../login-flow';

@Injectable()
export class LegacyLoginService implements LoginFlow {
  private learningPath = '';

  constructor(private readonly router: Router) {}

  shouldShowForm(): boolean {
    return usesAppLogin();
  }

  onInit(): void {
    if (!this.shouldShowForm()) {
      location.href = environment.oldFrontUrl + '/logout';
      return;
    }

    const FULL_URL = this.router.url;
    const INDEX = FULL_URL.indexOf('/learning');
    if (INDEX !== -1) {
      this.learningPath = FULL_URL.substring(INDEX).split('?')[0];
    }
  }

  async signIn(username: string, password: string): Promise<void> {
    const FORM = document.createElement('form');
    FORM.method = 'POST';
    FORM.action = environment.oldFrontUrl + '/login';

    if (this.learningPath) {
      const RETURN_INPUT = document.createElement('input');
      RETURN_INPUT.type = 'hidden';
      RETURN_INPUT.name = 'returnTo';
      RETURN_INPUT.value = this.learningPath;
      FORM.appendChild(RETURN_INPUT);
    }

    const INPUT_USERNAME = document.createElement('input');
    INPUT_USERNAME.type = 'hidden';
    INPUT_USERNAME.name = 'username';
    INPUT_USERNAME.value = username;

    const INPUT_PASSWORD = document.createElement('input');
    INPUT_PASSWORD.type = 'hidden';
    INPUT_PASSWORD.name = 'password';
    INPUT_PASSWORD.value = password;

    FORM.appendChild(INPUT_USERNAME);
    FORM.appendChild(INPUT_PASSWORD);

    document.body.appendChild(FORM);
    FORM.submit();
    document.body.removeChild(FORM);
  }
}
